"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FirmRepository_1 = __importDefault(require("../repositories/FirmRepository"));
var FirmService = /** @class */ (function () {
    function FirmService() {
    }
    FirmService.findByHost = function (host) {
        return __awaiter(this, void 0, void 0, function () {
            var firm, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.findByHost(host)];
                    case 1:
                        firm = _a.sent();
                        return [2 /*return*/, Promise.resolve(firm)];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.findByName = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var firm, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.findByName(name)];
                    case 1:
                        firm = _a.sent();
                        return [2 /*return*/, Promise.resolve(firm)];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.findByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var firmStoreLocator, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.findByAddress(address)];
                    case 1:
                        firmStoreLocator = _a.sent();
                        return [2 /*return*/, Promise.resolve(firmStoreLocator)];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getAllFirmsDTO, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getAll()];
                    case 1:
                        getAllFirmsDTO = _a.sent();
                        return [2 /*return*/, Promise.resolve(getAllFirmsDTO)];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getOne = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var firm, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getOne(id)];
                    case 1:
                        firm = _a.sent();
                        return [2 /*return*/, Promise.resolve(firm)];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getCashRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cashRegister, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getCashRegister()];
                    case 1:
                        cashRegister = _a.sent();
                        return [2 /*return*/, Promise.resolve(cashRegister)];
                    case 2:
                        e_6 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_6)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getAnnouncements = function () {
        return __awaiter(this, void 0, void 0, function () {
            var announcements, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getAnnouncements()];
                    case 1:
                        announcements = _a.sent();
                        return [2 /*return*/, Promise.resolve(announcements)];
                    case 2:
                        e_7 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_7)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getNewsFeed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newsfeeds, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getNewsFeed()];
                    case 1:
                        newsfeeds = _a.sent();
                        return [2 /*return*/, Promise.resolve(newsfeeds)];
                    case 2:
                        e_8 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_8)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getLastModification = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lastModification, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getLastModification()];
                    case 1:
                        lastModification = _a.sent();
                        return [2 /*return*/, Promise.resolve(lastModification)];
                    case 2:
                        e_9 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_9)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getReservations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reservations, e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getReservations()];
                    case 1:
                        reservations = _a.sent();
                        return [2 /*return*/, Promise.resolve(reservations)];
                    case 2:
                        e_10 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_10)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getMobileAppStoreSettings = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var mobileAppStoreSettings, e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getMobileAppStoreSettings(id)];
                    case 1:
                        mobileAppStoreSettings = _a.sent();
                        return [2 /*return*/, Promise.resolve(mobileAppStoreSettings)];
                    case 2:
                        e_11 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_11)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getTimeslots = function (date, deliveryMethod, products, categories, pickupPointId) {
        return __awaiter(this, void 0, void 0, function () {
            var timeslots, e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getTimeslots(date, deliveryMethod, products, categories, pickupPointId)];
                    case 1:
                        timeslots = _a.sent();
                        return [2 /*return*/, Promise.resolve(timeslots)];
                    case 2:
                        e_12 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_12)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.getTimeIntervals = function (timeslotId, date, deliveryMethod, products, categories, pickupPointId) {
        return __awaiter(this, void 0, void 0, function () {
            var intervals, e_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.getTimeIntervals(timeslotId, date, deliveryMethod, products, categories, pickupPointId)];
                    case 1:
                        intervals = _a.sent();
                        return [2 /*return*/, Promise.resolve(intervals)];
                    case 2:
                        e_13 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_13)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.checkPassword = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var check, e_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, FirmRepository_1.default.checkPassword(password)];
                    case 1:
                        check = _a.sent();
                        return [2 /*return*/, Promise.resolve(check)];
                    case 2:
                        e_14 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_14)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FirmService.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, FirmRepository_1.default.delete(id)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    FirmService.create = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, FirmRepository_1.default.create(entity)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    FirmService.partialUpdate = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, FirmRepository_1.default.partialUpdate(entity)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    FirmService.update = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, FirmRepository_1.default.update(entity)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    FirmService.getCustomLinks = function (firmId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, FirmRepository_1.default.getCustomLinks(firmId)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    FirmService.getGuestFields = function (deliveryMethod, pickupPointId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, FirmRepository_1.default.getGuestFields(deliveryMethod, pickupPointId)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    return FirmService;
}());
exports.default = FirmService;
